import { motion } from "framer-motion";
import { PACKAGE_GROUPS, PREWEDDING } from "../../content/site";
import { useBooking } from "../../context/BookingContext";
import { usePrices } from "../../hooks/useSiteData";
import { SectionHeading, Reveal, EASE } from "./Motion";
import { PackageCard } from "./PackageCard";
import { PreWeddingPackages } from "./PreWeddingPackages";
import { Floral } from "./Floral";

const TABS = [...PACKAGE_GROUPS.map((g) => ({ id: g.id, label: g.label })), { id: PREWEDDING.id, label: PREWEDDING.label }];

const TabBar = ({ tab, setTab }) => (
  <div className="relative inline-flex rounded-full border border-gold/30 bg-white/80 p-1.5 backdrop-blur" role="tablist" data-testid="packages-tabs">
    {TABS.map((t) => (
      <button
        key={t.id}
        role="tab"
        aria-selected={tab === t.id}
        onClick={() => setTab(t.id)}
        className={`relative z-10 whitespace-nowrap rounded-full px-3.5 py-2.5 text-[13px] font-medium tracking-wide transition-colors duration-300 sm:px-7 sm:text-sm ${tab === t.id ? "text-cream" : "text-ink"}`}
        data-testid={`tab-${t.id}`}
      >
        {tab === t.id && <motion.span layoutId="pkg-tab" className="absolute inset-0 -z-10 rounded-full bg-gold" transition={{ type: "spring", stiffness: 300, damping: 30 }} />}
        {t.label}
      </button>
    ))}
  </div>
);

export const Packages = () => {
  const { tab, setTab } = useBooking();
  const price = usePrices();
  const group = PACKAGE_GROUPS.find((g) => g.id === tab);
  const title = group ? group.title : PREWEDDING.title;
  return (
    <section id="packages" className="relative overflow-hidden section-pad" data-testid="packages-section">
      <Floral pos="tl" />
      <Floral pos="br" className="w-44 sm:w-64 lg:w-80" />
      <div className="relative z-10 mx-auto max-w-[1300px]">
        <SectionHeading eyebrow="Packages 2026" title="Choose your" script="perfect story" align="center" testid="packages-heading" />
        <Reveal className="mt-10 flex justify-center">
          <TabBar tab={tab} setTab={setTab} />
        </Reveal>
        <motion.p key={title} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="mt-8 text-center font-serif text-2xl italic text-gold-dark" data-testid="packages-title">
          {title}
        </motion.p>
        <motion.div key={tab} initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: EASE }} className="mt-14">
          {group ? (
            <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
              {group.tiers.map((t) => (
                <PackageCard key={t.key} group={group} t={t} price={price(t.key, t.price)} />
              ))}
            </div>
          ) : (
            <PreWeddingPackages price={price} />
          )}
        </motion.div>
        <p className="mt-12 text-center text-xs text-ink-soft">Travel charges extra for outstation events. See terms below.</p>
      </div>
    </section>
  );
};
